<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-select v-model='theLogInstance' clearable @change="theLogInstanceChange" size="small" placeholder="选择方法">
          <el-option
              v-for="item in theLogInstanceAll"
              :key="item.name"
              :label="item.label+'-'+item.name"
              :value="item.name" >
          </el-option>
        </el-select>
        <el-input
          v-model="getSysRabbitmqErrorLogList_data.srelError"
          placeholder="请输入错误信息"
          clearable
          size='small'
          style="max-width:200px;"/>
        <el-button
          v-click.getSysRabbitmqErrorLogList
          type="primary"
          icon='el-icon-search'
          size='small'
          style='margin-left:10px;'
        >搜索
        </el-button>
      </el-col>
    </el-row>

    <mytable ref="getSysRabbitmqErrorLogList"
      :tableColums='tableColums_getSysRabbitmqErrorLogList'
      api='getSysRabbitmqErrorLogList::srelId'
      updateapi='updateSysRabbitmqErrorLogStatus'
      :height="H-165" >
    </mytable> 

  </div>
</template>

<script>
export default {
  data() {
    return {
      theLogInstanceAll:[
        {name:"sysTask",label:"定时任务"},
        {name:"sysNotice",label:"发送通知"},
        {name:"sysNoticeRead",label:"更新用户全部通知为已读"},
        {name:"sysUpdateUserTokenOrLogin",label:"更新用户token时间和最后login时间"},
        {name:"sysLog",label:"记录日志"},
        {name:"sysOrder",label:"更新训战目标"},
        {name:"sysCircle",label:"开单发送动态圈"},
        {name:"sysOrderIncome",label:"结算积分业绩"},
        {name:"sysUserDefaultTarget",label:"设置用户默认目标"},
        {name:"sysPushOrder",label:"订单推送"},
        {name:"sysUpdateDataOnlineDaily",label:"更新统计数据"},
        {name:"sysLogRabbitmq",label:"rabbitmq消息消费失败记录"},
        {name:"sysOrderIncomeMax",label:"结算业绩-最大单"},
        {name:"sysChatUserAdd",label:"添加环信人员"},
        {name:"sysChatGroupAdd",label:"添加群聊人员"},
        {name:"sysDeleteDepartChatGroup",label:"删除战队群"},
        {name:"sysAddChatGroupToSql",label:"将未知群加入到数据库"},
        {name:"sysUserCustomBusiness",label:"推荐业务"},
      ],
      srelMethod:"",
      tableColums_getSysRabbitmqErrorLogList: {
        $selection: false,

        srelMethod: ['方法',160,],
        srelMsg: ['处理信息',200,],
        srelError: '错误日志',
        srelDes: '备注',
        createtime: ['创建时间',160,],
        serlStatus: ['状态',110,'@v-if: 1:未处理#danger, 2:已处理#success '],
        $operation: [
          '操作', 200,
          this.updateSysRabbitmqErrorLogStatus && `@text: 编辑状态#success
           @v-if: $row.serlStatus == 1
           @click: _confirm('确定要更新已处理吗?')
                   .trigger('updateSysRabbitmqErrorLogStatus',{srelId:$row.srelId})
                   .trigger('getSysRabbitmqErrorLogList')
          `,
        ],
      },

    };
  },

  watch: {
    
  },

  methods: {
    theLogInstanceChange(id){
      this.srelMethod=id;
      this.getSysRabbitmqErrorLogList({currentPage:1,srelMethod:this.srelMethod});
    },
  },

  created() {
    this.getSysRabbitmqErrorLogList();
  },
  mounted(){
    
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/data/RabbitmqErrorLog.vue